export default "__VITE_ASSET__Dma1l4Yd__"